import React from "react";
import ReactDOM from "react-dom";
import Shop from "./components/Shop";

const urlSearchParams = new URLSearchParams(window.location.search);
const store = urlSearchParams.get("store");
const hidePrices = urlSearchParams.get("hidePrice") ? true : false;

const stores = ["driesprong", "tuinextra"];
if (null === store || !stores.includes(store)) {
  require("./index.scss");
} else {
  require(`./assets/css/${store}.scss`);
}

ReactDOM.render(<Shop hidePrices={hidePrices} />, document.getElementById("root"));
